'use client'

import type { FC } from 'react'
import { Label } from 'ui/label'
import { Input } from 'ui/input'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

const TextField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <Label htmlFor={field.name}>{field.label}</Label>
            <div className='relative'>
                {field?.inputIcon ? field.inputIcon() : null}
                <Input
                    key={field.name}
                    name={field.name}
                    value={String(value ?? '')}
                    className={field?.inputIcon ? 'pl-6' : ''}
                    type={field.type as 'text' | 'email' | 'number'}
                    disabled={!!field?.disabled}
                    onChange={e => onChange(field.name, e.target.value, field)}
                    required={field.required}
                />
            </div>
        </FieldWrapper>
    )
}

export default TextField
